import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { InfoTooltip } from "~/components/info-tooltip";

interface SearchResultsIndicatorProps {
  count: number;
  total: number | null;
  isLoading?: boolean;
  tooltip: ReactNode;
  testId?: string;
}

// Result-count line shown under a page title: "X of Y" once the total is
// known, a loading placeholder until then, and a plain result count when
// there is no total (e.g. an open-ended search).
export const SearchResultsIndicator = ({
  count,
  total,
  isLoading = false,
  tooltip,
  testId,
}: SearchResultsIndicatorProps) => {
  const { t } = useTranslation(["components"]);

  const getText = () => {
    if (total !== null) {
      return t("components:searchResultsIndicator.booksOfTotal", {
        count,
        total,
      });
    }

    if (isLoading) {
      return t("components:searchResultsIndicator.loading");
    }

    return t("components:searchResultsIndicator.booksFound", { count });
  };

  return (
    <div className="flex items-center" data-testid={testId}>
      {getText()}
      <InfoTooltip
        text={tooltip}
        triggerClassName="ml-2 opacity-100"
        iconSize="small"
        side="right"
        testId="info-tooltip-trigger"
      />
    </div>
  );
};
